import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(application)/error.tsx");
